import { StrategicAxesRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: StrategicAxesRepository): Interactor {
  return ({ planzone, strategicAxis }) =>
    present(
      repository
        .saveStrategicAxis(planzone, strategicAxis)
        .then((savedStrategicAxis) => ({
          planzone,
          strategicAxis: savedStrategicAxis,
        }))
        .catch(() =>
          Promise.reject({
            planzone,
            strategicAxis,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
